// all methods that expect a 'date' expect date objects
export const getDaysAfterDate = (date, int) => {
  const daysAfter = new Date(date.toISOString());
  daysAfter.setDate(date.getDate() + int);
  return daysAfter;
};

export const getMonthsAfterDate = (date, int) => {
  const monthsAfter = new Date(date.toISOString());
  monthsAfter.setMonth(date.getMonth() + int);
  return monthsAfter;
};

export const getYearsAfterDate = (date, int) => {
  const yearsAfter = new Date(date.toISOString());
  yearsAfter.setFullYear(date.getFullYear() + int);
  return yearsAfter;
};

// returns a boolean if given date ends within this year
export const endsWithinThisYear = date => date.getFullYear() < getYearsAfterDate(new Date(), 1).getFullYear();
